import { render, staticRenderFns } from "./product-filters-list.vue?vue&type=template&id=36834f87"
import script from "./product-filters-list.vue?vue&type=script&lang=js"
export * from "./product-filters-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports